<template>
  <div class="left-chart-1 flex-col">
    <div class="top-table">
      <!-- 标题-->
      <div class="top-title">
        <div class="div-bg tabs1">
          <!-- el-row：整体在绿框内水平居中；side 列占位尽量窄，避免 Tab 挤向一侧 -->
          <el-row type="flex" justify="center" align="middle" class="tabs1-row">
            <el-col :span="2" class="tabs1-row__side">
              <el-dropdown :popper-append-to-body="false">
                <span class="el-dropdown-link">
                  <!-- <i class="el-icon-s-operation el-icon--right"></i> -->
                </span>
                <el-dropdown-menu slot="dropdown" :append-to-body=false style="width: 150px">
                  <el-dropdown-item @click.native="set_stat_range_month(1)">最近一个月</el-dropdown-item>
                  <el-dropdown-item @click.native="set_stat_range_month(3)">最近三个月</el-dropdown-item>
                  <el-dropdown-item @click.native="set_stat_range_month(6)">最近半年</el-dropdown-item>
                  <el-dropdown-item @click.native="set_stat_range_month(12)">最近一年</el-dropdown-item>
                  <el-dropdown-item @click.native="set_stat_range_month(3650)">全部日期</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="20" class="tabs1-row__tabs">
              <el-tabs
                  v-model="activeName"
                  @tab-click="handleClick"
                  style="margin-left: 0px;">
                <el-tab-pane label="省区开方量" name="sixth"></el-tab-pane>
                <el-tab-pane label="地办开方量" name="fifth"></el-tab-pane>
                <el-tab-pane label="诊所开方量" name="third"></el-tab-pane>
                <el-tab-pane label="诊所收入" name="fourth"></el-tab-pane>
                <el-tab-pane label="云诊所消沉" name="first"></el-tab-pane>
                <el-tab-pane label="Pad诊所消沉" name="second"></el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </div>
      </div>

      <div style="width: 100%; height: 260px">
        <!-- 轮播表 -->
        <dv-scroll-board
            class="table" ref="scrollBoard"
            :config="config"
            style="width: 100%; height: 260px"
        />
      </div>

      <left-circle></left-circle>
      <!-- 标题-->
      <div class="top-title flex-row-l-c" style="margin-top: 10px">
        <div class="tabs-title flex-row-r-c">
          <img src="~@/assets/large/tabs-title.png" style="width: 27px; height: 27px"/>
          <div class="tabs-title-dec">月份疾病趋势</div>
        </div>
        <div class="div-bg tabs2">
          <div class="paiming flex-row-l-c">
            <div class="paiming-top flex-row-c-c">TOP3</div>
            <i @click="show_disease_sel" class="el-icon-setting"
               style="position:relative;right: 0px;float: right;z-index: 101;width: 20%;">
            </i>
          </div>
        </div>
      </div>

      <div class="leftLine">
        <!-- key 必须为 string/number，不能用 date 数组引用（非原始值会触发 Vue 告警） -->
        <!-- Y 轴刻度略小于默认（Linemarker 内仍经 ls3ChartFont 随 V3 缩放） -->
        <LineChart
          id="f33i"
          path="disease_trend"
          :key="diseaseLineChartKey"
          :params="{ date_start: date_span_jb[0], date_end: date_span_jb[1] }"
          :yAxisLabelBasePx="14"
          height="280px"
          width="100%"
        />
      </div>

    </div>

    <div class="bottom-chart">
    </div>

    <el-dialog title="选择条件" append-to-body :visible.sync="diseaseSelVisible" width="350px">
      <el-date-picker
          v-model="date_span_jb"
          type="daterange"
          :append-to-body=false
          align="right" style="width:260px"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
      </el-date-picker>
    </el-dialog>
  </div>
</template>

<script>
import leftCircle from "./leftCircle.vue";
// import leftLine from "./leftLine.vue";
import LineChart from "@/views/charts/line";
import moment from "moment-timezone";

export default {
  name: "LeftChart1",
  components: {
    leftCircle,
    LineChart,
    // leftLine,
  },
  computed: {
    /**
     * 「月份疾病趋势」折线图强制重挂载用的 key，由日期区间拼成字符串
     * @returns {string}
     */
    diseaseLineChartKey() {
      const span = this.date_span_jb;
      if (!Array.isArray(span) || span.length < 2) {
        return "disease-trend";
      }
      return `${String(span[0])}-${String(span[1])}`;
    },
  },
  data() {
    return {
      activeName: "sixth",
      date_span_jb: [moment().subtract(200, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      activeName1: "sixth",
      stat_range_month: 1,
      diseaseSelVisible: false,
      config: {
        header: ["诊所名称", "城市", "最近使用时间"],
        headerHeight: "28",
        /** 可视数据行数略增，单行高度随容器均分变小（与 headerHeight 一起控制「行高」观感） */
        rowNum: 10,
        index: true,
        width: "100%",
        indexHeader: "序号",
        headerBGC: "rgba(96, 252, 178, .31)",
        evenRowBGC: "rgba(96, 252, 178, .05)",
        oddRowBGC: "rgba(96, 252, 178, .05)",
        columnWidth: [50, 200, 80, 150],
        align: ["center"],
        waitTime: 3000,
        data: [],
      },
      config2: {
        header: ["诊所名称", "城市", "值"],
        headerHeight: "28",
        /** 可视数据行数略增，单行高度随容器均分变小（与 headerHeight 一起控制「行高」观感） */
        rowNum: 10,
        index: true,
        width: "100%",
        indexHeader: "序号",
        headerBGC: "rgba(96, 252, 178, .31)",
        evenRowBGC: "rgba(96, 252, 178, .05)",
        oddRowBGC: "rgba(96, 252, 178, .05)",
        columnWidth: [50, 200, 80, 150],
        align: ["center"],
        waitTime: 3000,
        data: [],
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime());
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            start.setHours(0, 0, 0, 0)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '全部',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3650);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  mounted() {
    this.handleClick({"name": "sixth"});
  },
  methods: {
    refresh_chart(){

    },
    show_disease_sel() {
      this.diseaseSelVisible = true
    },
    set_stat_range_month(item) {
      this.stat_range_month = item;
      this.handleClick({"name": this.activeName});
    },
    open_detail() {
      console.log("e :>> ");
    },
    handleClick(e) {
      console.log("e :>> ", e);
      if (e.name == "first") {
        this.$http.get(process.env.VUE_APP_API_HOST + "/recent_absent_clinics_online?stat_range_month=" + this.stat_range_month).then((res) => {
          // console.log(res.data.data)
          var rows = []
          res.data.data.forEach(f => rows.push(["<a style='color: white' target='_blank' href='/#/clinic/clinic_info?clinic_id=" + f['clinic_id'] + "'>" + f['clinic_name'] + "</a>", f['city'], f['create_time']]));
          // this.$refs['scrollBoard'].updateRows(rows, 0)
          this.config = {
            header: ["诊所名称", "城市", "最近使用时间"],
        headerHeight: "30",
        rowNum: 10,
        indexHeader: "序号",
            index: true,
            headerBGC: "rgba(96, 252, 178, .31)",
            evenRowBGC: "rgba(96, 252, 178, .05)",
            oddRowBGC: "rgba(96, 252, 178, .05)",
            columnWidth: [75, 200, 80, 150],
            align: ["center"],
            waitTime: 3000,
            width: "100%",
            data: rows,
          }
        })
      } else if (e.name == "second") {

        this.$http.get(process.env.VUE_APP_API_HOST + "/recent_absent_clinics_pad?stat_range_month=" + this.stat_range_month).then((res) => {
          // console.log(res.data.data)
          var rows = []
          res.data.data.forEach(f => rows.push(["<a style='color: white' target='_blank' href='/#/clinic/clinic_info?clinic_id=" + f['clinic_id'] + "'>" + f['clinic_name'] + "</a>", f['city'], f['create_time']]));
          this.config = {
            header: ["诊所名称", "城市", "最近使用时间"],
            headerHeight: "30",
            rowNum: 12,
            index: true,
            width: "100%",
            indexHeader: "序号",
            headerBGC: "rgba(96, 252, 178, .31)",
            evenRowBGC: "rgba(96, 252, 178, .05)",
            oddRowBGC: "rgba(96, 252, 178, .05)",
            columnWidth: [75, 200, 80, 150],
            align: ["center"],
            waitTime: 3000,
            data: rows,
          }
        })
      } else if (e.name == "third") {
        this.$http.get(process.env.VUE_APP_API_HOST + "/query_kf_rank?stat_range_month=" + this.stat_range_month).then((res) => {
          var rows = []
          res.data.data.forEach(f => rows.push([
            "<a style='color: white' target='_blank' href='/#/clinic/clinic_info?clinic_id=" + f['clinic_id'] + "'>" + f['name'] + "</a>",
            f['city'],
            f['value']]));
          this.config = {
            header: ["诊所名称", "城市", "数值"],
        headerHeight: "28",
        rowNum: 10,
        indexHeader: "序号",
            index: true,
            width: "100%",
            headerBGC: "rgba(96, 252, 178, .31)",
            evenRowBGC: "rgba(96, 252, 178, .05)",
            oddRowBGC: "rgba(96, 252, 178, .05)",
            columnWidth: [75, 180, 80, 120],
            align: ["center"],
            waitTime: 3000,
            data: rows,
          }
        })
      } else if (e.name == "fourth") {
        this.$http.get(process.env.VUE_APP_API_HOST + "/query_xsl_rank?stat_range_month=" + this.stat_range_month).then((res) => {
          var rows = []
          res.data.data.forEach(f => rows.push([
            "<a style='color: white' target='_blank' href='/#/clinic/clinic_info?clinic_id=" + f['clinic_id'] + "'>" + f['name'] + "</a>", f['city'], f['value']]));
          this.config = {
            header: ["诊所名称", "城市", "数值"],
        headerHeight: "28",
        rowNum: 10,
        indexHeader: "序号",
            width: "100%",
            index: true,
            headerBGC: "rgba(96, 252, 178, .31)",
            evenRowBGC: "rgba(96, 252, 178, .05)",
            oddRowBGC: "rgba(96, 252, 178, .05)",
            columnWidth: [75, 200, 80, 150],
            align: ["center"],
            waitTime: 3000,
            data: rows,
          }
        })
      } else if (e.name == "fifth") {
        this.$http.get(process.env.VUE_APP_API_HOST + "/query_cfl_rank_diban?stat_range_month=" + this.stat_range_month).then((res) => {
          var rows = []
          res.data.data.forEach(f => rows.push([f['new_diban_name'], f['new_shengqu_name'], f['cfl']]));
          this.config = {
            width: "100%",
            header: ["地办名称", "所属省区", "处方数(个)"],
        headerHeight: "28",
        rowNum: 10,
        indexHeader: "序号",
            index: true,
            headerBGC: "rgba(96, 252, 178, .31)",
            evenRowBGC: "rgba(96, 252, 178, .05)",
            oddRowBGC: "rgba(96, 252, 178, .05)",
            columnWidth: [75, 120, 150, 150],
            align: ["center"],
            waitTime: 3000,
            data: rows,
          }
        })
      } else if (e.name == "sixth") {
        this.$http.get(process.env.VUE_APP_API_HOST + "/query_cfl_rank_shengqu?stat_range_month=" + this.stat_range_month).then((res) => {
          var rows = []
          /* 与 header 对应两列：省区名称、处方数（index:true 时序号列由组件自动生成，勿重复占一列） */
          res.data.data.forEach(f => rows.push([f['new_shengqu_name'], f['cfl']]));
          this.config = {
            width: "100%",
            header: ["所属省区", "处方数(个)"],
        headerHeight: "28",
        rowNum: 10,
        indexHeader: "序号",
            index: true,
            headerBGC: "rgba(96, 252, 178, .31)",
            evenRowBGC: "rgba(96, 252, 178, .05)",
            oddRowBGC: "rgba(96, 252, 178, .05)",
            /* 序号 + 省区 + 处方数，三列宽度 */
            columnWidth: [72, 140, 110],
            align: ["center"],
            waitTime: 3000,
            data: rows,
          }
        })
      }
    },
    handleClick1(e) {
      console.log("e :>> ", e);
    },
  },
};
</script>
<style>

.leftLine {
  width: 100%;
  height: 220px;
  color: #fff;
  /*margin-top: 10px;*/
}

.leftLine #lineChart {
  width: 100%;
  height: 100%;
}

.leftLine /deep/ .el-dialog__wrapper .el-dialog {
  background: url("~@/assets/large/bg.png") no-repeat center center;
  background-color: rgba(96, 252, 178, 0.4);
  background-size: 100%;
}

.leftLine /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body {
  padding: 0px;
}

.leftLine /deep/ .el-dialog__wrapper .el-dialog .el-dialog__header {
  padding: 0px;
}
</style>
<style lang="less" scoped>
.left-chart-1 {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

    .top-table {
    width: 100%;
    //overflow: hidden;
    /* 标题条公共样式 */
    .top-title {
      position: relative;
      border: 1px solid rgba(96, 252, 178, 0.4);
      background: url("~@/assets/large/border.png") rgba(96, 252, 178, 0.05);
      background-size: 100% 100%;
      padding: 8px 2px;
      box-sizing: border-box;

      .tabs-title {
        .tabs-title-dec {
          width: 118px;
          margin-left: 5px;
        }
      }

      .tabs1 {
        height: 100%;

        /* 与全局 .tabs1-row 配合：侧列收窄，Tab 列可伸缩，整体随行居中 */
        ::v-deep .tabs1-row__side.el-col {
          flex: 0 0 auto !important;
          width: auto !important;
          max-width: 36px;
          padding-right: 0;
        }

        ::v-deep .tabs1-row__tabs.el-col {
          flex: 0 1 auto !important;
          width: auto !important;
          max-width: 100%;
          min-width: 0;
        }

        .paiming {
          height: 34px;
          background-color: #4a5858;
          border-radius: 4px;
          margin-top: 15px;
          margin-right: 5px;

          .paiming-top {
            width: 72px;
            height: 34px;
            background: #60fcb2;
            border-radius: 4px;
            font-weight: 600;
            font-size: 18px;
            font-family: YouSheBiaoTiHei;
            color: #0d1014;
            margin-right: 15px;
            font-style: italic;
          }
        }
      }

      .tabs2 {
        height: 100%;
        width: calc(100% - 145px);

        .paiming {
          width: 100%;
          height: 34px;
          background-color: #4a5858;
          border-radius: 4px;
          margin-top: 5px;
          margin-right: 5px;

          .paiming-top {
            width: 72px;
            height: 34px;
            background: #60fcb2;
            border-radius: 4px;
            font-weight: 600;
            font-size: 18px;
            font-family: YouSheBiaoTiHei;
            color: #0d1014;
            margin-right: 15px;
            font-style: italic;
            padding: 0 5px;
          }
        }
      }
    }

    /* 左栏顶部 Tab 区：与轮播表同一绿框，压低整体高度 */
    > .top-title {
      height: 52px;
      min-height: 48px;
      padding: 4px 2px;
    }

    /* 「月份疾病趋势」等图表副标题：矮条 */
    .map .top-title {
      height: auto;
      min-height: 38px;
      max-height: 46px;
      padding: 4px 2px;
      display: flex;
      align-items: center;

      .tabs-title {
        width: auto;
        align-items: center;

        .tabs-title-dec {
          width: auto;
          font-size: 15px;
          font-weight: 600;
          line-height: 1.25;
          white-space: nowrap;
        }
      }

      img {
        width: 22px !important;
        height: 22px !important;
      }
    }

    .table {
      margin-top: 20px;

    }
  }

  .bottom-chart {
    margin-top: 20px;
    flex: 1;

    .chart-title {
      font-weight: bold;
      height: 50px;
      display: flex;
      align-items: center;
      font-size: 20px;
      justify-content: center;
    }
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 25px;
      margin-left: 20px;
    }
  }

  .lc2-header {
    padding-left: 10px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.left-chart-1 {
  /* 避免 Tab 所在 el-row 默认下边距撑高绿框 */
  .tabs1 .tabs1-row.el-row {
    margin-bottom: 0 !important;
    width: 100%;
  }

  .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: transparent;
    z-index: 1;
  }

  /* 左栏顶部：开方量等 Tab，压缩导航高度与上下留白；标题条在可用宽度内水平居中 */
  .tabs1 .el-tabs__header {
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .tabs1 .el-tabs__nav-wrap {
    min-height: 0;
    display: flex;
    justify-content: center;
  }

  .tabs1 .el-tabs__item {
    height: 30px;
    line-height: 30px;
    margin-top: 2px;
    margin-bottom: 0;
    padding: 0 6px;
    font-size: 13px;
    max-width: none;
    white-space: nowrap;
  }

  .tabs2 .el-tabs__item {
    margin-top: 6px;
    line-height: 34px;
    font-size: 14px;
  }

  .el-tabs__nav {
    padding-right: 4px;
  }

  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 34px;
    height: 34px;
    color: #b1b2b4;
    font-size: 16px;
  }

  .el-tabs__item {
    color: #ccc !important;
    text-align: center;
  }

  .is-active {
    color: #fff !important;
    font-weight: bold !important;
  }

  /*tabs 去掉el-tab-pane切换时的蓝色下划线*/
  .el-tabs__active-bar {
    height: 2px !important;
    background-color: rgba(96, 252, 178, 1) !important;
  }
}

// 动态表样式：略压表头与行内字号，配合 headerHeight/rowNum 让行更矮
.left-chart-1 .dv-scroll-board.table .header-item,
.left-chart-1 .dv-scroll-board.table .ceil {
  font-size: 12px !important;
}

/**
 * 滚动区单元格：水平居中 + 行高内垂直居中（避免文字贴顶、贴左）
 * 说明：config.align 对部分版本/DataV 行为不一致，用样式兜底
 */
.left-chart-1 .dv-scroll-board.table .ceil {
  line-height: normal !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  box-sizing: border-box;
}

/** 表头单元格：在 headerHeight 行高内垂直居中 */
.left-chart-1 .dv-scroll-board.table .header-item {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: normal !important;
  box-sizing: border-box;
}

/* 表头整行与各格同高，避免 flex 子项未拉高导致看起来偏上 */
.left-chart-1 .dv-scroll-board.table .header {
  margin: 0 !important;
  display: flex !important;
  align-items: stretch !important;
}

.dv-scroll-board .header {
  margin-bottom: 10px;
  margin-top: -10px;
}


</style>

